export default ({ theme }) => {
  return `
  .MuiBadge-dot {
    background-color: ${theme.alternateAccentColor}; /* Use theme color for the dot */
    width: 8px;
    height: 8px;
  }
  `;
}
